
import React from 'react';
import './kindle.css';

const Kindle = () => {
    return (
        <div className='page-basics'>
            <h2>ON MY KINDLE</h2>
            <p style={{ textAlign: 'center', fontSize: '12px', color: 'gray' }}>
                <img src='ReadMore.jpg' alt='Kindle' /> <br />
                Photo by Nicole Honeywill on Unsplash
            </p>

            <h3>Currently on my Kindle</h3>
            <p>

                <ul>
                    <li><a href='https://www.amazon.com/Let-Them-Theory-Life-Changing-Millions-ebook/dp/B0DKRVYQ17/ref=tmm_kin_swatch_0' target='_blank' rel="noreferrer">The Let Them Theory</a> - Mel Robbins</li>
                    <li><a href='https://www.amazon.com/Make-Your-Bed-things-change-ebook/dp/B0714M8P9Y/ref=sr_1_1?crid=3HIT0E93K3IQJ&dib=eyJ2IjoiMSJ9.m_SETOgWXsoBraqwqRk5dbf50YIsqGf0iVDoWbMWj6TFEu_g_mnOGSoXt9OZ9VOiDS6HHJWIc3n37UXatk83FGEWIkM50_EjSxhxqSdAy92AK8RJAqzl89MhEUKG_-9XEHls7gZjgJBccktNyWNVUftoD6TW38zAx_ioLs3NXzW_6STe47MLV0g44WZYPYioNdfVF2R5GmmENWGD-IuKBLB6iS3mYQKKuFcZtm_5xlM.ZuN-5vQGvG8pUnJNMMBt0H7M4-rmLR8JCfYgLiOmDLw&dib_tag=se&keywords=make+your+bed&qid=1719955500&s=digital-text&sprefix=make+your+be%2Cdigital-text%2C323&sr=1-1' target='_blank' rel="noreferrer">
                        Make Your Bed</a> – William H. McRaven</li>
                    <li><a href='https://www.amazon.com/Leading-Teams-Solutions-Everyday-Challenges-ebook/dp/B005D7V5MC/ref=sr_1_2?crid=1RF4I50H3U5O8&dib=eyJ2IjoiMSJ9.E2wx9uQ9fRbLRrll_E7SVuchg6ooAso__mBAIhNga6FrDmWgGViTog6xILqgGWA8QHJWHXWXiTdSQxlBe5chZylI7A849Pdycskq1cSrXT-goGfLR8AehbDkxgTUnXkH8M8nvIecScvuy97IvmX01hGkeFXJodyjgDRSDuWpdvOZrhYFv6QpqqQKgefyfXPL6a_zfmwrkjCpFAbJIc-C7f0MoTqpIRLw4AuVM8pdsNk.qMB1l8S4wb1ofK2a-tlYrXpacZpr7ucmOMKCbKkKJvg&dib_tag=se&keywords=leading+teams+expert+solutions+to+everyday+challenges&qid=1716744855&s=digital-text&sprefix=leading+teams+expert+solutions+to+everyday+challen%2Cdigital-text%2C315&sr=1-2' target='_blank' rel="noreferrer">
                        Leading Teams: Expert Solutions to Everyday Challenges</a> – Harvard Business School Publishing</li>
                    <li><a href='https://www.takealot.com/matjiesfontein-messages/PLID94672475' target='_blank' rel="noreferrer">
                        Matjiesfontein Messages And Other Thoughts From The Karoo</a> – Andrew Bramley</li>
                </ul>

                <br />

                <p className='blockquote'>Think before you speak. Read before you think.</p>  Fran Lebowitz

            </p>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

        </div>
    );
};

export default Kindle;